import { isSafeSlug } from "./isSafeSlug";

export interface ProductPathInput {
  id: string | number;
  slug?: string | null;
}

/**
 * Canonical URL for a dish.
 *
 * `Product.slug` is nullable and the backend generates it with no character
 * sanitisation (`name.replace(/\s+/g, "-").toLowerCase()`), so it can be absent or
 * contain path/query characters. Those products keep the legacy `?product={id}`
 * form — it still opens the right modal, it just isn't a canonical, indexable URL.
 * The sitemap skips anything that lands on the fallback.
 */
export function productPath(makerSlug: string, product: ProductPathInput): string {
  if (!isSafeSlug(product.slug)) return `/store/${makerSlug}?product=${product.id}`;
  return `/store/${makerSlug}/product/${product.slug}`;
}

/**
 * True when this product has a real canonical path (i.e. `productPath` did not
 * fall back to the query form). Use before advertising a product URL anywhere.
 */
export function hasCanonicalProductPath(product: ProductPathInput): boolean {
  return isSafeSlug(product.slug);
}
